export const REGEX_CONTAINS_ONE_LETTER_MINIMUM = /^(?=.*[a-zA-Z]).+$/;
export const REGEX_CONTAINS_ONE_NUMBER_MINIMUM = /^(?=.*\d).+$/;
export const REGEX_VALID_PHONE_FORMATTED = /^\([\d]{2,3}\)\s[\d]{3}-[\d]{4}/;
